import { render, staticRenderFns } from "./SubmissionDetail.vue?vue&type=template&id=47e3f174"
import script from "./SubmissionDetail.vue?vue&type=script&lang=js"
export * from "./SubmissionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports